export default __webpack_public_path__ + "static/media/NoticeCollage.a27d2ade.png";